export default __webpack_public_path__ + "static/media/AQ.76bb0c16.svg";